import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ChangeDetectorRef,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Roles, StaffStatus } from '@fitness-force/enum';
import { CustomAutomationData, STAFFINTERFACE } from '@fitness-force/models';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { STAFF_STATE } from 'apps/ff-frontend/src/app/state/app.state';
import { ToastMessageService } from '@fitness-force/api';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';

import { MultiSelectModule } from 'primeng/multiselect';
import { StyleClassModule } from 'primeng/styleclass';
import { distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'staff-notification-setting-popup',
  templateUrl: './staff-notification-setting-popup.component.html',
  styleUrls: ['./staff-notification-setting-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ToastMessageService],
  standalone: true,
  imports: [
    CommonModule,
    CheckboxModule,
    DialogModule,
    ButtonModule,
    StyleClassModule,
    MultiSelectModule,
    FormsModule,
    ReactiveFormsModule,
    AvatarModule,
    ShortNamePipe,
    TranslateModule
  ]
})
export class StaffNotificationSettingPopupComponent implements OnInit {
  @Input('visible') showPopup = false;
  @Input('firstTimeSelected') firstTimeSelected = false;
  @Input('Data') automationData: any;
  @Output('hide') HidePopup: EventEmitter<{
    closePopup: boolean;
    data: CustomAutomationData;
    showAnotherPopup: boolean;
  }> = new EventEmitter();

  modelData: CustomAutomationData = {} as CustomAutomationData;
  associatedStaffCheck: boolean = false;
  otherStaffCheck: boolean = false;
  accessedStaffs: STAFFINTERFACE[] = [];
  selectedStaff: any;
  staffNotificationForm: UntypedFormGroup = new UntypedFormGroup({});

  constructor(private cd: ChangeDetectorRef, private store: Store,private fb: FormBuilder) {
    this.staffNotificationForm = this.fb.group({
      notify_record_associated_staff:[false, Validators.required],
      notify_record_other_staff:[false],
      notify_additional_staff_to:[]
    });
  }

  ngOnInit(): void {
    this.store.select(STAFF_STATE).subscribe((staffs: any) => {
      this.accessedStaffs = staffs.staffList.filter(
        (s: STAFFINTERFACE) =>
          s.role !== Roles.FFAdmin &&
          s.role.toString() !== Roles[Roles.FFAdmin] &&
          (s.status === StaffStatus.Active ||
            s.status.toString() === StaffStatus[StaffStatus.Active])
      );
    });

    if (this.automationData) {
      this.modelData = this.automationData as CustomAutomationData;
      if (this.modelData.notificationSelected) {
        this.associatedStaffCheck = this.modelData.associatedStaff;
        if (this.modelData.additionalStaffTo.length > 0)
        {
          this.otherStaffCheck = true;
          this.selectedStaff = this.accessedStaffs.filter(o => this.modelData.additionalStaffTo.includes(o.id));
        }
        this.staffNotificationForm = this.modelData.staffNotificationForm;
      }
      this.cd.detectChanges();
    }

     this.SelectedOtherStaffFormControl.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((value: boolean) => {
        if(!value)
        {
          this.SelectedAdditionalStaffFormControl.setValue([]);
          this.SelectedAdditionalStaffFormControl.clearValidators();
        }
        else{
          this.SelectedAdditionalStaffFormControl.setValidators(Validators.required);
        }
      });
  }

  SelectNotificationSetting() {
    this.modelData.notificationSelected = true;
    this.modelData.associatedStaff = this.SelectedAssociatedStaffFormControl && this.SelectedAssociatedStaffFormControl.value ? this.SelectedAssociatedStaffFormControl.value  : false ;
    this.modelData.staffNotificationForm = this.staffNotificationForm;
    if (this.SelectedOtherStaffFormControl && this.SelectedOtherStaffFormControl.value) {
      this.modelData.additionalStaffTo = this.SelectedAdditionalStaffFormControl && this.SelectedAdditionalStaffFormControl.value ? this.SelectedAdditionalStaffFormControl.value.map((staff: any) => staff.id) : [];
    } 
    else{
      this.modelData.additionalStaffTo =[];
    }
    this.HidePopup.emit({
      closePopup: true,
      data: this.modelData,
      showAnotherPopup: this.firstTimeSelected,
    });
    //this.ref.close(this.modelData);
  }

  closePopup() {
    this.HidePopup.emit({
      closePopup: true,
      data: this.modelData,
      showAnotherPopup: false,
    });
  }

  get SelectedAdditionalStaffFormControl()
  {
    return this.staffNotificationForm.controls['notify_additional_staff_to'] as UntypedFormControl;
  }

  get SelectedAssociatedStaffFormControl()
  {
    return this.staffNotificationForm.controls['notify_record_associated_staff'] as UntypedFormControl;
  }

  get SelectedOtherStaffFormControl()
  {
    return this.staffNotificationForm.controls['notify_record_other_staff'] as UntypedFormControl;
  }
}